@if (zaehlerName(); as name) {
  <div class="grid w-100-p h-100" id="grid-tab-container">
    <div class="clr-row nxm clr-align-items-start">
      @if (!store.isReadOnly()) {
        <div class="btn-group btn-icon btn-primary margin-12-t">
          <button class="btn btn-success" type="submit" form="pruefung-form" [title]="'Speichern' | mrTranslate">
            <cds-icon shape="floppy" />
          </button>
          <ng-container *ngTemplateOutlet="helperBtn" />
        </div>
        @if (edit_messung()?.pruefung; as pruefung) {
          <form
            id="pruefung-form"
            #pruefungForm
            (ngSubmit)="saveIfValid()"
            clrForm
            clrLayout="vertical"
            class="width100 clr-col">
            <div class="clr-row nxm clr-align-items-baseline" style="gap: 25px">
              <clr-date-container class="mt-0 flex-1-0-auto">
                <label class="clr-required-mark" for="date">
                  {{ 'Datum' | mrTranslate }}
                </label>
                <input
                  type="date"
                  clrDate
                  name="P_ZDatum"
                  required
                  [ngModel]="pruefung.P_ZDatum | localeDate"
                  (ngModelChange)="pruefung.P_ZDatum = localeDate.tosql($event)"
                  [ngModelOptions]="{ updateOn: 'blur' }" />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Erforderlich' | mrTranslate }}
                </clr-control-error>
              </clr-date-container>
              <clr-control-container class="mt-0 flex-1-0-auto">
                <label class="clr-required-mark clr-col-md-12">
                  {{ 'Messender' | mrTranslate }}
                </label>
                <app-datalist-input
                  [datalist]="messenderList()"
                  name="P_ZUser"
                  [(ngModel)]="pruefung.P_ZUser"
                  required
                  class="clr-col-md-12" />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Erforderlich' | mrTranslate }}
                </clr-control-error>
              </clr-control-container>
              <clr-control-container class="mt-0 flex-1-0-auto">
                <label class="clr-col-md-12">
                  {{ 'Messgerät' | mrTranslate }}
                </label>
                <app-datalist-input
                  [datalist]="messgeraeteList()"
                  name="M_Device"
                  [(ngModel)]="pruefung.M_Device"
                  class="clr-col-md-12" />
              </clr-control-container>
              <clr-textarea-container class="mt-0 clr-col nxp" style="flex: 1 3 200px; min-width: 200px">
                <label>{{ 'Bemerkung' | mrTranslate }}</label>
                <textarea rows="2" clrTextarea name="P_Bemerkung" [(ngModel)]="pruefung.P_Bemerkung"></textarea>
              </clr-textarea-container>
            </div>
          </form>
        }
      } @else {
        <ng-container *ngTemplateOutlet="helperBtn" />
        <!-- <div class="btn-group btn-icon btn-outline margin-12-t">
        </div> -->
        @if (edit_messung()?.pruefung; as pruefung) {
          <form clrForm clrLayout="vertical" class="width100 clr-col">
            <div class="clr-row nxm clr-align-items-baseline" style="gap: 15px">
              <clr-input-container class="mt-0">
                <label>{{ 'Datum' | mrTranslate }}</label>
                <input clrInput type="text" readonly [value]="pruefung.P_ZDatum | localeDate" />
              </clr-input-container>
              <clr-input-container class="mt-0">
                <label>{{ 'Messender' | mrTranslate }}</label>
                <input clrInput type="text" readonly [value]="pruefung.P_ZUser" />
              </clr-input-container>
              @if (pruefung.M_Device) {
                <clr-input-container class="mt-0">
                  <label>{{ 'Messgerät' | mrTranslate }}</label>
                  <input clrInput type="text" readonly [value]="pruefung.M_Device" />
                </clr-input-container>
              }
              @if (pruefung.P_Bemerkung) {
                <clr-input-container class="mt-0">
                  <label>{{ 'Bemerkung' | mrTranslate }}</label>
                  <input clrInput type="text" readonly [value]="pruefung.P_Bemerkung" />
                </clr-input-container>
              }
            </div>
          </form>
        }
      }
      <ng-template #helperBtn>
        @if (name.HasHelper) {
          <button
            class="btn btn-icon btn-outline margin-12-t"
            [title]="'Beschreibung' | mrTranslate"
            (click)="isHelperModalOpen.set(true)">
            <cds-icon shape="help" />
          </button>
        }
      </ng-template>
    </div>
    @if (messungen() && tol()) {
      @if (werte_checklist.isLoading()) {
        <clr-spinner class="centred" />
      } @else {
        @let columns = werte_checklist.value().columns | filterTolByOptions: name;
        <clr-datagrid
          class="datagrid-compact h-100 w-100-p sticky-action-column"
          [clrDgItemsIdentityFn]="row => row.ID">
          @if (!store.isReadOnly()) {
            <clr-dg-column class="sticky-action" style="width: 64px">
              <button type="button" class="btn btn-primary btn-icon btn-sm nm" (click)="editNextRow(index())">
                <cds-icon
                  shape="step-forward"
                  solid="true"
                  [title]="(index() == 0 ? 'Starten' : 'Weiter') | mrTranslate"></cds-icon>
              </button>
            </clr-dg-column>
          }
          @for (column of columns; track column.id) {
            <clr-dg-column>
              <ng-container
                *clrDgHideableColumn="{
                  hidden:
                    column.id
                    | hideIDColumns
                      : [
                          'szaehnid',
                          'i_sort',
                          'zeinheit',
                          'username',
                          'status',
                          'zart',
                          'ztype',
                          'sgenau',
                          'tgenau',
                          'aktivsrlimm',
                          'aktivsr100',
                          'aktivsrg',
                          'lastid',
                          'track'
                        ],
                }">
                {{ column.id | transformColNames: tol() | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          @if (edit_messung()?.unsaved) {
            <clr-dg-column>
              {{ 'Ist' | mrTranslate }}
              <cds-icon shape="note" class="margin-3-lr" />
            </clr-dg-column>
            <clr-dg-column>{{ 'Tol. Verl.' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Bemerkung' | mrTranslate }}</clr-dg-column>
          }
          @for (group of messungen(); track group.pruefung.OPRUEFID) {
            <clr-dg-column>
              {{ 'Ist' | mrTranslate }} - {{ group.pruefung.Column_Datum }}
              @if (group.pruefung.OPRUEFID == edit_messung()?.pruefung.OPRUEFID) {
                <cds-icon shape="note" class="margin-3-lr" />
              }
            </clr-dg-column>
            <clr-dg-column>{{ 'Tol. Verl.' | mrTranslate }} - {{ group.pruefung.Column_Datum }}</clr-dg-column>
            <clr-dg-column>{{ 'Bemerkung' | mrTranslate }} - {{ group.pruefung.Column_Datum }}</clr-dg-column>
          }
          <clr-dg-row
            *clrDgItems="let row of checklist(); let i = index"
            [clrDgItem]="row"
            id="i-{{ row.ID }}"
            [class.headerRow]="row.ZType == ZType_Header">
            @if (!store.isReadOnly()) {
              <clr-dg-cell class="sticky-action" style="width: 64px">
                @if (row.ZType != ZType_Header) {
                  <button type="button" class="btn btn-icon btn-sm nm h-auto" (click)="editNextRow(i)">
                    <cds-icon shape="pencil" [title]="'Bearbeiten' | mrTranslate" />
                  </button>
                }
              </clr-dg-cell>
            }
            @for (cell of columns; track cell.id) {
              <clr-dg-cell class="name-cell" [class.sticky-action]="row.ZType == ZType_Header && cell.id == 'Code'">
                {{ row | werteRowValues: cell.id | tablePrettyPrint }}
              </clr-dg-cell>
            }

            <ng-container>
              @if (edit_messung()?.unsaved) {
                <clr-dg-cell class="name-cell">
                  {{ edit_messung()?.messwerte[i]?.Ist.toString() | mrTranslate }}
                </clr-dg-cell>
                <clr-dg-cell class="noover">
                  @if (edit_messung()?.messwerte[i]?.Ausfall; as ausfall) {
                    <span class="label ausfall" [style.--ausfall-color]="ausfall | getAusfallColor: tol()">
                      {{ ausfall }}
                    </span>
                  }
                </clr-dg-cell>
                <clr-dg-cell class="name-cell">{{ edit_messung()?.messwerte[i]?.Bemerkung }}</clr-dg-cell>
              }
              @for (group of messungen(); track group.pruefung.OPRUEFID) {
                <clr-dg-cell class="name-cell">{{ group.messwerte[i]?.Ist }}</clr-dg-cell>
                <clr-dg-cell class="noover">
                  @if (group.messwerte[i]?.Ausfall; as ausfall) {
                    <span class="label ausfall" [style.--ausfall-color]="ausfall | getAusfallColor: tol()">
                      {{ ausfall }}
                    </span>
                  }
                </clr-dg-cell>
                <clr-dg-cell class="name-cell">{{ group.messwerte[i]?.Bemerkung }}</clr-dg-cell>
              }
            </ng-container>
          </clr-dg-row>
          <clr-dg-footer>{{ checklist().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
      <clr-modal [(clrModalOpen)]="isOpenModal" [clrModalSize]="'xl'">
        <div class="modal-title">
          <h3>{{ 'Zählererfassung' | mrTranslate }}</h3>
        </div>
        <div class="modal-body grid" id="grid-form-container">
          <div id="preview">
            <ng-container *ngTemplateOutlet="preview" />
          </div>
          @if (checklist()[index()]; as selected) {
            <form
              id="erfassung-form"
              [formGroup]="erfassungForm"
              (ngSubmit)="saveRow()"
              clrForm
              [clrLabelSize]="4"
              class="width100 grid no-margin text-center"
              clrLayout="vertical">
              <h3 [style.grid-area]="'code'">{{ selected.Code }}</h3>

              @if (ZArt_Options.get(+selected.ZArt); as mode) {
                @if (mode.soll.input != 'Select') {
                  <clr-number-input-container [style.grid-area]="'ist'">
                    <label class="clr-align-self-end">
                      <span hidden>{{ 'Ist' | mrTranslate }}</span>
                      <button
                        class="btn btn-sm btn-icon btn-link clr-col-auto nm"
                        style="text-transform: lowercase"
                        tabindex="-1"
                        type="button"
                        [title]="'Toggle n.g.' | mrTranslate"
                        (click)="erfassungForm.controls.Ist.setValue('n.g.')">
                        {{ 'n.g.' | mrTranslate }}
                      </button>
                    </label>
                    <input clrNumberInput type="number" formControlName="Ist" [placeholder]="'n.g.' | mrTranslate" />
                    <!-- <clr-control-error *clrIfError="'required'">
                      {{ "Erforderlich" | mrTranslate }}
                    </clr-control-error> -->
                  </clr-number-input-container>
                } @else {
                  <clr-select-container [style.grid-area]="'ist'">
                    <label hidden>{{ 'Ist' | mrTranslate }}</label>
                    <select clrSelect formControlName="Ist">
                      <option value="n.g.">{{ 'n.g.' | mrTranslate }}</option>
                      <option value="Ja">{{ 'Ja' | mrTranslate }}</option>
                      <option value="Nein">{{ 'Nein' | mrTranslate }}</option>
                    </select>
                  </clr-select-container>
                }
                @if (erfassungForm.value.Ausfall; as ausfall) {
                  <span
                    class="label ausfall"
                    [style.grid-area]="'ausfall'"
                    [style.--ausfall-color]="ausfall | getAusfallColor: tol()">
                    {{ ausfall }}
                  </span>
                }
                <ng-container
                  *ngTemplateOutlet="
                    readonlyInput;
                    context: { label: 'Soll-Wert', control: 'Soll', area: 'soll', mode: mode.soll }
                  " />
                @if (mode.minus) {
                  @if (name.isSR100 && selected.aktivSR100) {
                    <ng-container
                      *ngTemplateOutlet="
                        readonlyInput;
                        context: {
                          label: 'SR100minus' | transformColNames: tol(),
                          control: 'SR100minus',
                          area: 'sr100-minus',
                          mode: mode.minus,
                        }
                      " />
                  }
                  @if (selected.aktivSRlimm) {
                    <ng-container
                      *ngTemplateOutlet="
                        readonlyInput;
                        context: {
                          label: 'SRlimminus' | transformColNames: tol(),
                          control: 'SRlimminus',
                          area: 'srlim-minus',
                          mode: mode.minus,
                        }
                      " />
                  }
                  @if (name.isSRG && selected.aktivSRG) {
                    <ng-container
                      *ngTemplateOutlet="
                        readonlyInput;
                        context: {
                          label: 'SRGminus' | transformColNames: tol(),
                          control: 'SRGminus',
                          area: 'srg-minus',
                          mode: mode.minus,
                        }
                      " />
                  }
                  @if (mode.plus) {
                    @if (name.isSR100 && selected.aktivSR100) {
                      <ng-container
                        *ngTemplateOutlet="
                          readonlyInput;
                          context: {
                            label: 'SR100plus' | transformColNames: tol(),
                            control: 'SR100plus',
                            area: 'sr100-plus',
                            mode: mode.plus,
                          }
                        " />
                    }
                    @if (selected.aktivSRlimm) {
                      <ng-container
                        *ngTemplateOutlet="
                          readonlyInput;
                          context: {
                            label: 'SRlimplus' | transformColNames: tol(),
                            control: 'SRlimplus',
                            area: 'srlim-plus',
                            mode: mode.plus,
                          }
                        " />
                    }
                    @if (name.isSRG && selected.aktivSRG) {
                      <ng-container
                        *ngTemplateOutlet="
                          readonlyInput;
                          context: {
                            label: 'SRGplus' | transformColNames: tol(),
                            control: 'SRGplus',
                            area: 'srg-plus',
                            mode: mode.plus,
                          }
                        " />
                    }
                  }
                }
                <ng-template #readonlyInput let-label="label" let-control="control" let-mode="mode" let-area="area">
                  <clr-input-container [style.grid-area]="area" style="justify-self: center">
                    <label>{{ label | mrTranslate }}</label>
                    <input
                      clrInput
                      type="text"
                      readonly
                      [value]="mode.text + ' ' + ((control | addTol: selected) ?? '')" />
                  </clr-input-container>
                </ng-template>
              }

              <clr-textarea-container [style.grid-area]="'bemerkung'" class="fill-space">
                <label>{{ 'Bemerkung' | mrTranslate }}</label>
                <textarea clrTextarea formControlName="Bemerkung"></textarea>
              </clr-textarea-container>

              <clr-input-container [style.grid-area]="'bezeichnung'">
                <label>{{ 'Bezeichnung' | mrTranslate }}</label>
                <input clrInput type="text" [value]="selected.Bezeichnung" readonly />
              </clr-input-container>

              <clr-input-container [style.grid-area]="'zart'">
                <label>{{ 'Zählerart' | mrTranslate }}</label>
                <input clrInput type="text" [value]="ZArt_Map.get(+selected.ZArt) ?? ''" readonly />
              </clr-input-container>
            </form>
          }
        </div>
        <div class="modal-footer clr-align-items-baseline">
          @if (checklist().length) {
            <div class="clr-col">
              <div id="nav-row" class="grid">
                @let isFirst = index() == 0;
                @let isLast = index() == checklist().length - 1;
                @let prev = checklist() | at: index() - 1;
                @let next = checklist() | at: index() + 1;
                @if (!isFirst) {
                  <button
                    (click)="editPrevRow()"
                    type="button"
                    class="btn btn-link np nm text-right"
                    style="justify-self: end"
                    [style.grid-area]="'prev'"
                    [title]="'vorherige Wert öffnen' | mrTranslate">
                    {{ prev.Code }}
                  </button>
                }
                <button
                  (click)="editPrevRow()"
                  [disabled]="isFirst || (index() == 1 && prev.ZType == ZType_Header)"
                  type="button"
                  class="btn np nm btn-link btn-state btn-state-custom-size"
                  [style.grid-area]="'prev-btn'"
                  [title]="'vorherige Wert öffnen' | mrTranslate">
                  <cds-icon
                    direction="left"
                    [shape]="!isFirst && prev.ZType == ZType_Header ? 'angle-double' : 'circle-arrow'" />
                </button>
                <button
                  (click)="editNextRow()"
                  [disabled]="isLast"
                  type="button"
                  class="btn np nm btn-link btn-state btn-state-custom-size"
                  [style.grid-area]="'next-btn'"
                  [title]="'nächste Wert öffnen' | mrTranslate">
                  <cds-icon
                    direction="right"
                    [shape]="!isLast && next.ZType == ZType_Header ? 'angle-double' : 'circle-arrow'" />
                </button>
                @if (!isLast) {
                  <button
                    (click)="editNextRow()"
                    type="button"
                    class="btn btn-link np nm text-left"
                    [style.grid-area]="'next'"
                    style="justify-self: start"
                    [title]="'nächste Wert öffnen' | mrTranslate">
                    {{ next.Code }}
                  </button>
                }
              </div>
            </div>
          }
          <button type="submit" form="erfassung-form" class="btn btn-primary">
            <cds-icon shape="step-forward" solid="true" />
            {{ 'Speichern & weiter' | mrTranslate }}
          </button>
        </div>
      </clr-modal>
    }
    <ng-container *ngTemplateOutlet="preview" />
  </div>
  <app-hilfe-beschreibung-modal
    [(isModalOpen)]="isHelperModalOpen"
    [table]="'SZAEHN'"
    [id]="name.ID"
    [readonly]="true" />
}
<ng-template #preview>
  @if (skizzeRs.hasValue()) {
    <app-preview-thumbnails
      [data]="[{ base64: skizzeRs.value(), name: `${zaehlerName().Bild}.png` }]"
      [readonly]="true"
      [isSkizze]="true" />
  }
</ng-template>
